import { inject, Injectable, Injector, untracked } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { ActionReducerMap } from '@ngrx/store';
import { Store } from '@ngrx/store';
import type { IUserStatus } from '@rdlabo/odss-mobile-hono/src/api/auth/api';
import type { Signal } from '@angular/core';

import { reducer, setUserStatus } from './status';

export interface MobileStoreState {
  status: IUserStatus;
}

export const reducers: ActionReducerMap<MobileStoreState> = {
  status: reducer,
};

@Injectable({ providedIn: 'root' })
export class UserStatusStore {
  readonly #store$ = inject<Store<MobileStoreState>>(Store);
  readonly #injector = inject(Injector);
  #status?: Signal<IUserStatus | undefined>;

  get statusSignal(): Signal<IUserStatus | undefined> {
    return (this.#status ??= untracked(() => toSignal(this.#store$.select('status'), { injector: this.#injector })));
  }

  setUserStatus(status: IUserStatus): void {
    this.#store$.dispatch(setUserStatus({ status }));
  }
}
